<nav
  class="rounded-xl border border-slate-200 bg-white px-4 py-3.5 shadow-sm mt-3 mb-3"
  aria-label="Circled Intelligence steps"
>
  <ol class="flex flex-wrap gap-2">
    @for (step of steps(); track step.id) {
      <li>
        <button
          type="button"
          [disabled]="!isReachable(step)"
          (click)="stepSelect.emit(step.id)"
          [attr.aria-current]="isCurrent(step) ? 'step' : null"
          class="rounded-full border px-4 py-2 text-sm font-medium whitespace-nowrap
                 transition-colors focus:outline-none focus-visible:ring-2
                 focus-visible:ring-indigo-500 focus-visible:ring-offset-2
                 disabled:cursor-not-allowed"
          [class]="pillClass(step)"
        >
          {{ pad(indexOf(step)) }} · {{ step.label }}
        </button>
      </li>
    }
  </ol>
</nav>
